import React from 'react';
import { CarbonIconType } from '@carbon/icons-react';
import { Link } from '@reach/router';
import DashboardPageCard from './DashboardPageCard';

const ProductCard: React.FC<{
  icon: CarbonIconType;
  name: string;
  description: string;
  path: string;
  color: string;
  label?: string;
  isExternalLink?: boolean;
}> = ({ icon, name, description, color, path, label, isExternalLink }) => {
  const cardContent = (
    <DashboardPageCard
      icon={icon}
      title={name}
      text={description}
      color={color}
      label={label}
    />
  );

  return isExternalLink ? (
    <a
      href={path}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="product-link"
    >
      {cardContent}
    </a>
  ) : (
    <Link to={path} data-testid="product-link">
      {cardContent}
    </Link>
  );
};

export default ProductCard;
